import { render, staticRenderFns } from "./ehc-phone-Input.vue?vue&type=template&id=8c084bba&scoped=true"
import script from "./ehc-phone-Input.vue?vue&type=script&lang=js"
export * from "./ehc-phone-Input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c084bba",
  null
  
)

export default component.exports